import NotificationsDrawer from './NotificationsDrawer.component';

export default NotificationsDrawer;